import { gql } from "@apollo/client";

export const ACTUALIZAR_ESTADO_SOLICITUDES = gql`
    mutation ActualizarEstadoSolicitudes {
        actualizarEstadoSolicitudes
    }
`;